import React, { useState, useEffect } from 'react';
import { authFetch } from '../auth';
import './markdownLinks.css';

const IMG_RE = /\.(png|jpe?g|gif|webp|svg|avif|bmp)(\?|#|$)/i;
export function isImageUrl(u) { return typeof u === 'string' && IMG_RE.test(u); }

// Rich Open Graph card for a bare link. Falls back to a plain link while loading or on failure.
export function LinkPreview({ url }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    authFetch('/api/linkpreview?url=' + encodeURIComponent(url))
      .then(r => (r && r.ok) ? r.json() : null)
      .then(d => { if (alive && d && !d.error && (d.title || d.image)) setData(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, [url]);

  if (!data) {
    return <a href={url} target="_blank" rel="noopener noreferrer" className="md-link">{url}</a>;
  }
  let host = data.siteName || '';
  if (!host) { try { host = new URL(url).hostname.replace(/^www\./, ''); } catch (e) {} }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="md-linkcard">
      {data.image ? (
        <span className="md-linkcard-img" style={{ backgroundImage: 'url("' + String(data.image).replace(/["\\]/g, '') + '")' }} />
      ) : null}
      <span className="md-linkcard-body">
        <span className="md-linkcard-title">{data.title}</span>
        {data.description ? <span className="md-linkcard-desc">{data.description}</span> : null}
        <span className="md-linkcard-site">{host}</span>
      </span>
    </a>
  );
}

// react-markdown component overrides:
//  - an image URL used as a link → inline <img> (graphic link)
//  - a paragraph that is ONLY a bare link → image embed or a preview card (unfurl)
export const linkMarkdownComponents = {
  a: function MdAnchor({ href, children }) {
    if (isImageUrl(href)) return <img src={href} alt="" className="md-img" loading="lazy" />;
    return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
  },
  p: function MdParagraph({ node, children }) {
    const kids = ((node && node.children) || []).filter(c => !(c.type === 'text' && !String(c.value || '').trim()));
    if (kids.length === 1 && kids[0].type === 'link') {
      const href = kids[0].url;
      const tc = kids[0].children && kids[0].children[0];
      const text = tc && tc.value;
      if (href && (!text || text === href)) {
        if (isImageUrl(href)) return <p><img src={href} alt="" className="md-img" loading="lazy" /></p>;
        return <LinkPreview url={href} />;
      }
    }
    return <p>{children}</p>;
  }
};
